export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.068 20.684A.75.75 0 015.625 20v-2.25H5A2.75 2.75 0 012.25 15V7A2.75 2.75 0 015 4.25h14A2.75 2.75 0 0121.75 7v8A2.75 2.75 0 0119 17.75h-8.965l-3.162 2.81a.75.75 0 01-.805.124zm1.057-2.354l2.127-1.89a.75.75 0 01.498-.19H19c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h1.375a.75.75 0 01.75.75v1.33z\" fill=\"#6F7488\"/><circle cx=\"16\" cy=\"11\" r=\"1\" fill=\"#6F7488\"/><circle cx=\"12\" cy=\"11\" r=\"1\" fill=\"#6F7488\"/><circle cx=\"8\" cy=\"11\" r=\"1\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};